import React from "react"
import RestrictedHeadear from "../RestrictedHeader"
import CallToAction from "../CallToAction"

const restrictedMessage = ({ data, sendEmail }) => {
  return (
    <div className="restricted__container">
      <div className="restricted__body">
        {RestrictedHeadear(data.title, data.subtitle)}
        <CallToAction
          text={data.message}
          buttonText={"Get in Touch"}
          action={sendEmail}
        />
      </div>
    </div>
  )
}

export default restrictedMessage
